import { styled, View } from 'tamagui';

export const ActiveTabIndicator = styled(View, {
  transition: '200ms',
  position: 'absolute',
  y: '$8',
  height: '$0.5',
  borderRadius: '$4',
  zIndex: 1,

  enterStyle: {
    opacity: 0
  },
  exitStyle: {
    opacity: 0
  },

  variants: {
    active: {
      true: {
        backgroundColor: '$unistocks',
        opacity: 0.8
      }
    },

    hover: {
      true: {
        backgroundColor: '$unistocks',
        opacity: 0.5
      }
    }
  } as const
});
